import { User } from 'lucide-react'
import { Employee } from '../types'

interface EmployeeCardProps {
  employee: Employee
  assignedCount: number
  type: 'chef' | 'delivery'
}

export const EmployeeCard = ({ employee, assignedCount, type }: EmployeeCardProps) => {
  return (
    <div className="flex items-center justify-between p-2.5 sm:p-3 bg-white/60 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-white/60 hover:bg-white/80 hover:shadow-md transition-all duration-200">
      <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
        <div className={`w-9 h-9 sm:w-10 sm:h-10 rounded-xl sm:rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md ${
          type === 'chef' 
            ? 'bg-gradient-to-br from-blue-500 to-blue-600 shadow-blue-500/20' 
            : 'bg-gradient-to-br from-orange-500 to-orange-600 shadow-orange-500/20'
        }`}>
          <User className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-xs sm:text-sm text-gray-900 truncate">{employee.name}</p>
          <p className="text-[10px] sm:text-xs text-gray-600 truncate">{employee.email}</p>
        </div>
      </div>
      <div className="text-right flex-shrink-0 ml-2">
        <p className="text-sm sm:text-base font-bold text-gray-900">{assignedCount}</p>
        <p className="text-[10px] sm:text-xs text-gray-500 uppercase tracking-wide">activos</p>
      </div>
    </div>
  )
}

